import { combineReducers } from 'redux';
import list from './list';

export const urlsReducers = combineReducers({
  list,
});
